import axios from "axios";

const isDev = process.env.NODE_ENV === "development";

const api = axios.create({
  baseURL: isDev ? "/api/" : "https://api.q.daqinjiaoyu.cn/api/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");
    if (token) {
      config.headers["Token"] = token;
    }
    if (userId) {
      config.headers["user_id"] = userId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 点击签到
export const qiandao = (data) => {
  return api.post("setqiandao/qiandao", data);
};
// 微信登录
export const weixinlog = (data) => {
  return api.post("login/weixinlog", data);
};
// 获取用户信息
export const getLoginInfo = (accesstoken) => {
  return api.get("login/getloginfo", {
    params: { accesstoken },
  });
};
//更新用户真实姓名
export const updateUserInfo = (data) => {
  return api.post("login/updateuserinfo", data);
};

export const getAddress = (location) => {
  return api.get("map/getmapaddress", {
    params: { location },
  });
};
export const getclassroom = (classroomid) => {
  return api.get("setqiandao/getclassroomdata", {
    params: { classroomid },
  });
};

export const getWechatJsConfig = (url) => {
  return api.get("wechat/getJsConfig", {
    params: { url },
  });
};
export default api;
